import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1LocationCitiesQueryOptions,
  useDeleteApiV1LocationCitiesId,
} from '@/shared/api/generated';

/**
 * Hook para excluir uma Cidade.
 *
 * Envolve o mutation gerado pelo Kubb para `DELETE /api/v1/location/cities/{id}`
 * e invalida o cache da listagem após a exclusão bem-sucedida.
 */
export function useDeleteCity() {
  const queryClient = useQueryClient();

  return useDeleteApiV1LocationCitiesId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1LocationCitiesQueryOptions());
      },
    },
  });
}
